<template>
  <div class='detail'>
    <back />
    <div class="content">
      <el-descriptions title="基本信息：" :column="4">
        <el-descriptions-item label="申请时间 ">{{data.createdTime	}} </el-descriptions-item>
        <el-descriptions-item label="联系人">{{data.contactMan}}</el-descriptions-item>
        <el-descriptions-item label="联系电话">{{data.contactTel}}</el-descriptions-item>
        <el-descriptions-item label="联系邮箱">{{data.contactEmail}}</el-descriptions-item>
      </el-descriptions>
    </div>
    <el-divider></el-divider>
    <div class="leave_msg">
      <el-descriptions title="留言内容：" :colon="false" :column="1">
        <el-descriptions-item>{{ data.applyContent }}</el-descriptions-item>
      </el-descriptions>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      data: {}
    }
  },
  created() {
    this.selectCompanyApplyInfoDetail()
  },
  methods: {
    selectCompanyApplyInfoDetail() {
      this.$axios.get(this.$api.selectCompanyApplyInfoDetail, { params: { id: this.$route.query.id } }).then((res) => {
        if (res.code == 100) {
          console.log(res)
          this.data = res.result
        }
      }).catch(err => {
        this.$message({
          message: err.desc,
          type: 'error'
        })

      })
    }
  },
}
</script>

<style scoped lang='scss'>
.detail {
  .content {
    margin-top: 30px;
  }

  .content,
  .leave_msg {
    ::v-deep .el-descriptions__title {
      color: #1a1a1a;
      font-size: 18px;
    }
  }

  .leave_msg {
    ::v-deep .el-descriptions-item__label {
      margin: 0;
    }
  }
}
</style>
